<template>
    <div class="main-body">
        <h2>{{ $strings('word/rate_pack') }}</h2>
        <!--        <div class="action-bar">-->
        <!--            <div class="add-wrapper">-->
        <!--            </div>-->
        <!--            <div class="filter-wrapper">-->
        <!--                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">-->
        <!--                    <el-form-item label="">-->
        <!--                        <el-input v-model="formFilter.sp_name" placeholder="CpName" size="small"-->
        <!--                                  class="max-width-120" clearable></el-input>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item>-->
        <!--                        <el-button @click="onFilter" size="small">{{ $strings('word/query') }}</el-button>-->
        <!--                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>-->
        <!--                    </el-form-item>-->
        <!--                </el-form>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column prop="cp_id" :label="$strings('word/cp')">
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.cp_id }}</span></template>
                </el-table-column>
                <el-table-column prop="country" :label="$strings('word/country')">
                    <template slot-scope="scope">
                        <span>{{ countryName(scope.row.country) }} ({{ scope.row.country }})</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" :label="$strings('word/amount')"></el-table-column>
                <el-table-column prop="price" :label="$strings('word/price')"></el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {CTS, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {GetItem} from "@/utils/storage";
import FlagByCountryCode from "@/utils/flag";
import {CpSitePackRead} from "@/api/cpsite/api";
import {UnixToDateFull} from "@/utils/time";

export default {
    name: "spsite-cppack",
    data() {
        return {
            loading: true,
            formFilter: {},
            tableData: [],
            options: {
                cts: CTS,
            }
        }
    },
    mounted() {
        this.refreshData();
    },
    computed: {},
    methods: {
        countryName(ct) {
            let country = '/';
            this.options.cts.forEach((item) => {
                if (item.value === ct) {
                    country = FlagByCountryCode(item.value) + " " + item.label + " ";
                }
            })
            return country;
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter = {};
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        refreshData() {
            this.loading = true;
            CpSitePackRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.rows.length > 0 ? resp.data.data.rows : [];
            }).finally(() => {
                this.loading = false;
            })
        },
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>